'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import styled from 'styled-components'

export const MenuOptionWrapper = styled.div`
  color: #000;
`

export const BuyNewCarsDropDownWrapper = styled.div``

export const Title = styled.a`
  cursor: pointer;
  text-decoration: none;
  &:hover {
    color: #0b753e;
  }
`

export const ActiveLine = styled.div<{ isActive: boolean | undefined }>`
  color: #5b5675;
  ${(props) =>
    props.isActive &&
    `
    color: #000;
    border-bottom: 0.1875rem solid #0FA457;
  `};
`
export const MenuOption = styled.div<{
  fontSize: string
  fontWeight: string
  lineHeight: string
}>`
  font-size: ${(props) => props.fontSize || '1.125rem'};
  font-weight: ${(props) => props.fontWeight || '600'};
`
